/**
 * Lightweight CSV export utility. No dependencies.
 * Maps an array of rows through a column spec and triggers a browser download.
 */
function escapeCell(value) {
    if (value === null || value === undefined) return "";
    const str =
        typeof value === "object" ? JSON.stringify(value) : String(value);
    if (/[",\n]/.test(str)) return `"${str.replace(/"/g, '""')}"`;
    return str;
}

/**
 * Export rows to CSV.
 * @param {Array<object>} rows - the dataset
 * @param {Array<{key: string, label?: string, map?: (row)=>any}>} columns
 * @param {string} filename - download filename (without extension)
 */
export function exportToCsv(rows, columns, filename = "export") {
    if (!rows || rows.length === 0) return;
    const header = columns.map((c) => escapeCell(c.label ?? c.key)).join(",");
    const body = rows
        .map((row) =>
            columns
                .map((c) =>
                    escapeCell(c.map ? c.map(row) : row[c.key])
                )
                .join(",")
        )
        .join("\n");
    const blob = new Blob([header + "\n" + body], {
        type: "text/csv;charset=utf-8;",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${filename}-${new Date().toISOString().slice(0, 10)}.csv`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
}
